<div *ngIf="speiseplan" id="speiseplan-kunde-meldungen">
  <div *ngIf="speiseplan.bestellschluss[0].text != '' && kunde"
       (click)="openDialog(speiseplan.bestellschluss[0].text)"
       (keydown.enter)="openDialog(speiseplan.bestellschluss[0].text)"
       tabindex="0"
       class="dialog-buttons">
    <mat-icon>alarm</mat-icon>
    <span>Bestellschlussinfo</span>
  </div>
  <div *ngIf="(pdf_plaene | json) != '{}'"
       (click)="openPDF()"
       (keydown.enter)="openPDF()"
       tabindex="0"
       class="dialog-buttons">
    <mat-icon>picture_as_pdf</mat-icon>
    <span>Speiseplan PDF</span>
  </div>
</div>
